"use client";

import { Route } from "@faire/web-api/Route";
import { props as openWithFaireRouteProps } from "@faire/web-api/routes/open-with-faire";
import React from "react";

import { OpenWithFaireRouter } from "@faire/retailer/views/open-with-faire/OpenWithFaireRouter";

export const RenderOpenWithFaireRouter = () => (
  <Route {...openWithFaireRouteProps} component={OpenWithFaireRouter} />
);
